<template>
  <div class="MedicenCata">
    <div class="main">
      <div class="main-right" ref="mainRight">
        <div class="main-icon"
             style="display: flex; align-items: center; padding: 8px 10px; background: #fff; border-bottom: 1px solid #ebeef5;">
          <div class="main-icon-a" style="display: flex; align-items: center; margin-right: 15px;">
            <i :class="iconComes"
               style="border-radius: 50%; font-size: 20px; padding: 6px; background-color: #5a5a5a; color: #fff;"></i>
            <span style="font-size: 12px; font-weight: bold; margin-left: 8px; color: #606266;">{{
                CatalogueName
              }}</span>
          </div>
          <div style="display: flex; align-items: center; flex-wrap: nowrap;">
            <div style="display: flex; align-items: center; margin-right: 20px; white-space: nowrap;">
              <span style="font-size: 12px; color: #606266; font-weight: bold; margin-right: 8px;">关键字:</span>
              <el-input v-model="queryConditionForm.name" size="mini" style="width: 180px;"
                        @keyup.enter.native="loadData"></el-input>
            </div>
            <div style="display: flex; align-items: center;">
              <el-button v-for="(v,i) in headerBtn" :key="i" :type="v.type" :loading="loading" :icon="v.icon"
                         size="mini"
                         v-if="!v.auth || $store.getters.hasPermission(v.auth)"
                         :style="{...v.style, 'margin-left': '6px'}"
                         @click="handClick(i)">{{ v.title }}
              </el-button>
            </div>
          </div>
        </div>

        <div class="table">
          <el-table :data="tableData" border @row-dblclick="handleDbShowData" show-summary
                    :summary-method="getSummaries">
            <el-table-column v-for="(col, inx) in tableRows" :key="inx" :type="col.type" :prop="col.prop"
                             :label="col.name" :render-header="labelHead"
                             :min-width="getColumnWidth(col.label,col.prop,tableData)"
                             header-align="center">
              <template #default="{ row }">{{ safeGetMappedValue(col, row) }}</template>
            </el-table-column>
            <el-table-column fixed="left" label="行号" type="index"></el-table-column>
            <el-table-column fixed="right" label="操作" width="148"
                             v-if="$store.getters.hasPermission('system:clinicFeeManagement:edit')">
              <template #default="scope">
                <div class="editbox" style="text-align: center;">
                  <el-button type="primary" @click="handleClinicFeeChargeAgainst(scope.row)" size="mini"
                             :disabled="scope.row.nuyState !== 0">冲销
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <el-dialog
            :title='addClinicFeeManagementForm.id == null ? "新增一般费用" : (showClinicFeeManagementDialogVisible ? "查看一般费用" : "修改一般费用")'
            :visible.sync="addClinicFeeManagementDialogVisible" :close-on-click-modal="false" width="700px"
            @close="handleCloseClinicFeeManagement" class="custom-form-dialog">
          <el-form size="mini" :model="addClinicFeeManagementForm" ref="addClinicFeeManagementForm"
                   :rules="addClinicFeeManagementFormRules" label-width="110px" label-position="right"
                   :disabled="showClinicFeeManagementDialogVisible">
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="费用名称:" prop="name">
                  <el-input v-model="addClinicFeeManagementForm.name" placeholder="请输入完整名称" clearable/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="资金账户:" prop="capitalAccount">
                  <el-cascader v-model="selectedFinanceClassId1" :options="financeClassCascaderOptions"
                               :props="cascaderProps"
                               style="width: 100%" clearable filterable @change="handleFinanceClassCascaderChange1"
                               :show-all-levels="true" :disabled="financeClassLoading">
                    <template slot-scope="{ data }">
                      <span :class="{ 'disabled-text': data.disabled }">{{ data.label }}</span>
                      <span v-if="data.type" style="margin-left: 8px;">
                        <el-tag :type="getFinanceClassTagType(data.type)" size="mini"
                                effect="plain">{{ getFinanceClassTypeText(data.type) }}</el-tag>
                      </span>
                    </template>
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="报销人:" prop="rebPersion">
                  <el-select v-model="addClinicFeeManagementForm.rebPersion">
                    <el-option v-for="item in staffListOptions" :key="item.id" :label="item.label" :value="item.id"/>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="发生时间:" prop="busTime">
                  <el-date-picker v-model="addClinicFeeManagementForm.busTime" type="date" placeholder="选择日期"
                                  value-format="yyyy-MM-dd" style="width: 100%"/>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="金额:" prop="amount">
                  <el-input-number v-model="addClinicFeeManagementForm.amount" :min="0" :precision="2"
                                   controls-position="right" style="width: 100%"/>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="支出项目:" prop="type">
                  <el-cascader v-model="selectedFinanceClassId2" :options="financeClassCascaderOptionsExpend"
                               :props="cascaderProps"
                               style="width: 100%" clearable filterable @change="handleFinanceClassCascaderChange2"
                               :show-all-levels="true" :disabled="financeClassLoading">
                    <template slot-scope="{ data }">
                      <span :class="{ 'disabled-text': data.disabled }">{{ data.label }}</span>
                      <span v-if="data.type" style="margin-left: 8px;">
                        <el-tag :type="getFinanceClassTagType(data.type)" size="mini"
                                effect="plain">{{ getFinanceClassTypeText(data.type) }}</el-tag>
                      </span>
                    </template>
                  </el-cascader>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="20">
              <el-col :span="12">
                <el-form-item label="部门:" prop="deptId">
                  <el-select v-model="addClinicFeeManagementForm.deptId">
                    <el-option v-for="item in deptOptions" :key="item.id" :label="item.label" :value="item.id"/>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
            <el-form-item label="备注:">
              <el-input type="textarea" v-model="addClinicFeeManagementForm.remarks" :rows="3"
                        placeholder="可输入额外说明信息" resize="none" show-word-limit maxlength="200"/>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button :disabled="showClinicFeeManagementDialogVisible" size="mini" type="primary"
                       @click="handleAddFinancialSummaryAccount">保存
            </el-button>
            <el-button :disabled="showClinicFeeManagementDialogVisible" size="mini"
                       @click="handleCloseClinicFeeManagement">取消
            </el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <el-pagination class="fixed-pagination" @size-change="handleSizeChange" @current-change="handleCurrentChange"
                   :current-page="pageNum" :page-sizes="[8, 16, 24]" :page-size="pageSize" :total="totalSize"
                   layout="total, sizes, prev, pager, next, jumper" background/>
  </div>
</template>

<script>
import {pinyin} from "pinyin-pro";
import {getContuntList, getDeptList} from "@/api/reservation/reservation";
import {getDoctorList} from "@/api/scheduling/scheduling";
import dayjs from "dayjs";
import {withLoading} from "@/untils/loading";
import {
  addClinicFeeManagement,
  editClinicFeeManagement,
  getClinicFeeChargeAgainst,
  getClinicFeeManagementById,
  getClinicFeeManagementPage
} from "@/api/clinicFeeManagement/clinicFeeManagement";
import {
  getFinancialSummaryAccountList,
  getOneFinancialSummaryAccountById
} from "@/api/financialSummaryManagement/financialSummaryAccount";
import {selectDropDownList} from "@/api/PSI";
import {getAllFinanceclass, getFinanceclassList} from "@/api/clasificacionContable/clasificacionContable";

export default {
  components: {},
  data() {
    return {
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周', onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近一个月', onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          },
          {
            text: '最近三个月', onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }
        ]
      },
      defaultProps: {children: 'children', label: 'label'},
      windowWidth: '',
      searchValue: '',
      CatalogueName: '一般费用',
      DropDownedName: '全部',
      state: null,
      iconComes: 'el-icon-byj',
      queryConditionForm: {name: ''},
      loading: false,
      addClinicFeeManagementDialogVisible: false,
      showClinicFeeManagementDialogVisible: false,
      pageNum: 1,
      pageSize: 8,
      totalSize: 10,
      applyobjectOptions: [{id: 0, label: '全部'}, {id: 1, label: '门诊'}, {id: 2, label: '住院'}],
      stateOption: [{id: 0, label: '禁用'}, {id: 1, label: '可用'}],
      doctorOptions: [],
      addClinicFeeManagementFormRules: {
        amount: [{required: true, message: ' ', trigger: 'change'}],
        name: [{required: true, message: ' ', trigger: 'blur'}],
        busTime: [{required: true, message: ' ', trigger: 'blur'}],
        rebPersion: [{required: true, message: ' ', trigger: 'blur'}],
      },
      addClinicFeeManagementForm: {
        id: null, amount: null, name: "", remarks: "", busTime: '', rebPersion: null,
        capitalAccount: null, expendType: null, deptId: null, type: 1
      },
      financeClassData: [],
      selectedFinanceClassId1: null,
      selectedFinanceClassId2: null,
      cascaderProps: {
        value: 'id',
        label: 'name',
        children: 'children',
        checkStrictly: false,
        emitPath: false   // 直接返回选中的叶子节点ID，而不是数组
      },
      financeClassCascaderOptions: [],      // 资金账户树
      financeClassCascaderOptionsExpend: [], // 支出项目树
      financeClassLoading: false,
      tableData: [],
      headerBtn: [
        {search: "search", title: "搜索", type: "success", style: {marginLeft: "-20px"}},
        {add: "add", title: "新增", type: "warning", auth: 'system:clinicFeeManagement:add'},
      ],
      elTree: [{label: '全部', path: '', title: '', icon: 'el-icon-news', children: []}],
      tableRows: [
        {name: "名称", prop: "name"},
        {name: "资金账户", prop: "capitalAccount", op: 'financeclassOptions'},
        {name: "支出类型", prop: "expendType", op: 'financeclassOptions'},
        {name: "金额", prop: "amount"},
        {name: "冲销金额", prop: "nuyAmt"},
        {name: "冲销状态", prop: "nuyState", op: 'nuyOption'},
        {name: "冲销人", prop: "nuyUserName"},
        {name: "冲销时间", prop: "nuyTime"},
        {name: "创建人", prop: "createName"},
        {name: "创建时间", prop: "createTime"},
        {name: "备注", prop: "remarks"},
      ],
      nuyOption: [{id: 0, label: '否'}, {id: 1, label: '冲销原单'}, {id: 2, label: '冲销负单'}],
      expenseCategoryOptions: [],
      allExpenseCategoryOptions: [],
      financialOptions: [],
      supplierOptions: [],
      staffListOptions: [],
      financeclassOptions: [],
      deptOptions: [],
      balanceTypeOptions: [{id: 1, label: '支出'}, {id: 2, label: '收入'}],
    };
  },
  async mounted() {
    await this.loadData();
    await this.getFinancial();
    this.allExpenseCategoryOptions = this.$store.getters['preload/getCostTypeOptions'] || [];
    this.supplierOptions = this.$store.getters['preload/getSupplierListOption'] || [];
    this.staffListOptions = this.$store.getters['preload/getStaffListOptions'] || [];
    this.deptOptions = this.$store.getters['preload/getDeptListOptions'];
    await this.getSupplierOptions();
    await this.loadFinanceClassData();
    await this.getFinanceclassList();
  },
  methods: {
    async getFinanceclassList() {
      // 这里用全量（不传 status），因为历史单据可能引用了已禁用的科目，表格名称映射需要能查到
      const res = await getFinanceclassList();
      // id 统一转字符串，保证与表格 row 的 capitalAccount/expendType 严格匹配
      this.financeclassOptions = res.map(item => ({id: String(item.id), label: item.name}));
    },

    /**
     * 按接口文档 type 动态构建树
     * type: 1收入 2支出 3资金账户 4资产 5负债
     * - 只保留 type 匹配的节点
     * - 根节点 = parentId 不在当前 type 节点集合内（或 parentId 为 "0"）
     * - 不写死任何 id，接口增删分类前端自动适配
     */
    buildTreeByType(list, type) {
      const idSet = new Set();
      list.forEach(item => {
        if (item.type === type) idSet.add(item.id);
      });
      if (idSet.size === 0) return [];

      const nodeMap = new Map();
      list.forEach(item => {
        if (!idSet.has(item.id)) return;
        nodeMap.set(item.id, {
          id: item.id,
          name: item.name,
          label: item.name,
          type: item.type,
          parentId: item.parentId,
          orderNum: item.orderNum,
          children: []
        });
      });

      // 只连同一 type 内的父子关系
      list.forEach(item => {
        if (!idSet.has(item.id)) return;
        const node = nodeMap.get(item.id);
        if (item.parentId && nodeMap.has(item.parentId)) {
          nodeMap.get(item.parentId).children.push(node);
        }
      });

      // 根节点：parentId 不在当前 type 集合内
      const roots = [];
      nodeMap.forEach(node => {
        if (!node.parentId || !nodeMap.has(node.parentId)) {
          roots.push(node);
        }
      });

      // 清理空 children，避免级联选择器出现空白展开箭头
      const cleanTree = (node) => {
        if (node.children.length === 0) {
          delete node.children;
        } else {
          node.children.forEach(cleanTree);
        }
      };
      roots.forEach(cleanTree);

      return roots;
    },

    /**
     * 【核心新增】过滤禁用节点及其所有子孙
     * 逻辑：从根节点递归，某个节点一旦被禁用，它和它所有的子节点都不展示
     * 原因：如果只过滤禁用节点本身，启用子级会因为找不到父级而变成级联树第一层的孤立根节点
     */
    filterEnabledWithDescendants(list) {
      // 建立 父 id -> 子节点 映射
      const childMap = new Map();
      list.forEach(item => {
        const pid = item.parentId || '0';
        if (!childMap.has(pid)) childMap.set(pid, []);
        childMap.get(pid).push(item);
      });

      const disabledIds = new Set();

      const traverse = (node, parentDisabled = false) => {
        const isDisabled = parentDisabled || Number(node.status) === 0;
        if (isDisabled) {
          disabledIds.add(node.id);
        }
        const children = childMap.get(node.id) || [];
        children.forEach(child => traverse(child, isDisabled));
      };

      // 从所有根节点开始遍历（parentId='0' 或没有父节点）
      const roots = list.filter(item => !item.parentId || item.parentId === '0');
      roots.forEach(root => traverse(root));

      // 过滤：保留不在禁用集合中的节点
      return list.filter(item => !disabledIds.has(item.id));
    },

    async loadFinanceClassData() {
      try {
        this.financeClassLoading = true;
        const res = await getFinanceclassList();

        // 统一 id / parentId 为字符串，status 转数字
        const allList = res.map(item => ({
          ...item,
          id: String(item.id),
          parentId: item.parentId != null ? String(item.parentId) : '0',
          status: item.status != null ? Number(item.status) : 1
        }));

        // 【关键】过滤：禁用节点 + 禁用节点的所有子孙 都不展示
        const list = this.filterEnabledWithDescendants(allList);

        // 资金账户：type = 3
        this.financeClassCascaderOptions = this.buildTreeByType(list, 3);

        // 支出项目：type = 2
        this.financeClassCascaderOptionsExpend = this.buildTreeByType(list, 2);

        console.log('资金账户树（已过滤禁用）:', this.financeClassCascaderOptions);
        console.log('支出项目树（已过滤禁用）:', this.financeClassCascaderOptionsExpend);
      } catch (error) {
        console.error('加载财务分类失败:', error);
      } finally {
        this.financeClassLoading = false;
      }
    },

    handleFinanceClassCascaderChange1(value) {
      this.addClinicFeeManagementForm.capitalAccount = value;
    },
    handleFinanceClassCascaderChange2(value) {
      this.addClinicFeeManagementForm.expendType = value;
    },
    getFinanceClassTagType(type) {
      switch (type) {
        case 1:
          return 'success';
        case 2:
          return 'danger';
        case 3:
          return 'primary';
        default:
          return 'info';
      }
    },
    getFinanceClassTypeText(type) {
      switch (type) {
        case 1:
          return '收入';
        case 2:
          return '支出';
        case 3:
          return '资金';
        case 4:
          return '资产';
        case 5:
          return '负债';
        default:
          return '其他';
      }
    },
    async getSupplierOptions() {
      const res = await selectDropDownList();
      this.supplierOptions = res.data.content.map(item => ({id: item.id, label: item.supplierName}));
    },
    getSummaries(param) {
      const {columns, data} = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        }
        if (column.property === 'amount' || column.property === 'nuyAmt') {
          const values = data.map(item => Number(item[column.property]));
          if (!values.every(v => isNaN(v))) {
            sums[index] = values.reduce((prev, curr) => prev + (isNaN(curr) ? 0 : curr), 0);
            sums[index] = '¥ ' + sums[index].toFixed(2);
          } else {
            sums[index] = 'N/A';
          }
        } else {
          sums[index] = '';
        }
      });
      return sums;
    },
    async handleClinicFeeChargeAgainst(row) {
      try {
        await this.$confirm(`确认冲销【${row.name}】吗？`, '冲销确认', {
          confirmButtonText: '确认冲销',
          cancelButtonText: '取消',
          type: 'warning',
          confirmButtonClass: 'el-button--danger'
        });
        const res = await getClinicFeeChargeAgainst({id: row.id});
        if (res.code === 200) {
          this.$message.success(res.message);
          await this.loadData();
        } else {
          this.$message.error(res.message || "系统异常:请联系管理员");
        }
      } catch (error) {
        if (error !== 'cancel') this.$message.info('已取消冲销操作');
      }
    },
    async handleAddFinancialSummaryAccount() {
      try {
        await this.$refs.addClinicFeeManagementForm.validate();
      } catch (error) {
        this.$message.warning("请完善表单信息");
        return;
      }
      await withLoading(this, '数据提交中...')(async () => {
        let res;
        if (!this.addClinicFeeManagementForm.id) res = await addClinicFeeManagement(this.addClinicFeeManagementForm);
        else res = await editClinicFeeManagement(this.addClinicFeeManagementForm);
        if (res.code === 200) {
          this.handleCloseClinicFeeManagement();
          await this.loadData();
          this.$message.success('操作成功');
        } else {
          this.$message.error(res.message || '操作失败');
        }
      });
    },
    handleCloseClinicFeeManagement() {
      this.addClinicFeeManagementForm = Object.assign({}, this.$options.data.call(this).addClinicFeeManagementForm);
      this.selectedFinanceClassId1 = null;
      this.selectedFinanceClassId2 = null;
      this.$nextTick(() => {
        this.$refs.addClinicFeeManagementForm?.clearValidate();
      });
      this.addClinicFeeManagementDialogVisible = false;
      this.showClinicFeeManagementDialogVisible = false;
    },
    async handleDbShowData(row) {
      const res = await getClinicFeeManagementById(row.id);
      if (res.code === 200) {
        this.addClinicFeeManagementForm = {...res.data};
        // 回显时统一转字符串，保证与级联选项 id 严格匹配
        this.selectedFinanceClassId1 =
            this.addClinicFeeManagementForm.capitalAccount != null
                ? String(this.addClinicFeeManagementForm.capitalAccount)
                : null;
        this.selectedFinanceClassId2 =
            this.addClinicFeeManagementForm.expendType != null
                ? String(this.addClinicFeeManagementForm.expendType)
                : null;
        this.addClinicFeeManagementDialogVisible = true;
        this.showClinicFeeManagementDialogVisible = true;
      } else {
        this.$message.error(res.message || "系统异常:请联系管理员");
      }
    },
    async loadData() {
      try {
        const res = await getClinicFeeManagementPage({
          pageSize: this.pageSize,
          pageNum: this.pageNum,
          name: this.queryConditionForm.name || '',
          type: 1
        });
        if (res.code === 200) {
          this.totalSize = res.data.totalSize;
          this.tableData = res.data.content;
        } else {
          this.$message.error(res.message);
        }
      } catch (error) {
        this.$message.error("系统异常:请联系管理员");
      }
    },
    async handClick(i) {
      switch (i) {
        case 0:
          await this.loadData();
          break;
        case 1:
          this.addClinicFeeManagementDialogVisible = true;
          this.selectedFinanceClassId1 = null;
          this.selectedFinanceClassId2 = null;
          break;
      }
    },
    async getFinancial() {
      const res = await getFinancialSummaryAccountList({type: 2});
      this.financialOptions = res.data.map(item => ({id: item.id, label: item.name, code: item.code}));
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageNum = 1;
      this.loadData();
    },
    handleCurrentChange(val) {
      this.pageNum = val;
      this.loadData();
    },
    getColumnWidth(label, prop, tableData) {
      const minWidth = 80;
      const padding = 20;
      const contentList = tableData.map(item => item?.[prop] ?? '');
      const widths = [...contentList, label].map(text => this.getTextWidth(String(text || '')) + padding);
      return Math.max(minWidth, ...widths);
    },
    getTextWidth(text, fontSize = 14) {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      ctx.font = `${fontSize}px Microsoft YaHei`;
      return ctx.measureText(text).width;
    },
    labelHead(h, {column}) {
      column.minWidth = 12 * (column.label.length + 5);
      return h("div", {class: "table-head", style: {width: "100%"}}, [column.label]);
    },
    safeGetMappedValue(col, row) {
      const rawValue = row[col.prop];
      if (rawValue === null || rawValue === undefined) return ' ';
      const mapArray = this[col.op];
      if (!col.op || !Array.isArray(mapArray)) return rawValue;
      const matched = mapArray.find(item => String(item.id) === String(rawValue));
      return matched?.label || rawValue;
    },
  }
}
</script>

<style lang="less" scoped>
.disabled-text {
  color: #c0c4cc;
  cursor: not-allowed;
}

.el-tag--plain[disabled] {
  opacity: 0.6;
}

.fixed-pagination {
  position: fixed;
  bottom: 20px;
  left: 190px;
  right: 0;
  background: #fff;
  padding: 10px;
  box-shadow: 0 -1px 5px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
  width: calc(100% - 200px);
  margin: 0 auto;
}

.fixed-pagination .el-pagination {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 0 auto;
  gap: 8px;
  max-width: 100%;
}

/deep/ .el-form-item {
  margin-bottom: 8px !important;
}

/deep/ .el-form-item .el-form-item__label {
  padding-bottom: 0 !important;
  line-height: 20px !important;
  height: 20px !important;
}

/deep/ .el-form-item .el-form-item__content {
  line-height: 20px !important;
}

/deep/ .el-tabs__item {
  padding: 0 10px !important;
  height: 30px !important;
  line-height: 30px !important;
}

/deep/ .el-dialog__header {
  padding: 12px;
  background-color: #007bb0;
}

/deep/ .el-dialog__title {
  font-size: 12px;
  color: #fff;
}

/deep/ .el-dialog__headerbtn .el-dialog__close {
  color: #fff;
}

/deep/ .el-input.is-disabled .el-input__inner {
  color: #87898f;
}

/deep/ .el-textarea.is-disabled .el-textarea__inner {
  color: #87898f;
}

/deep/ .el-dropdown-menu__item {
  font-size: 12px;
}

/deep/ .el-dialog__body {
  padding: 12px;
}

/deep/ .el-color-picker__icon, .el-input, .el-textarea {
  width: 100%;
}

/deep/ .el-pagination {
  padding: 6px;
}

.MedicenCata {
  height: 100%;
  width: 100%;
}

.MedicenCata .main {
  width: 100%;
  margin-left: 8px;
  display: flex;
  justify-content: left;
  overflow-y: auto;
}

.MedicenCata .main .main-right {
  flex: 1;
  width: 100%;
  height: 100%;
}

.MedicenCata .main .main-right .main-icon {
  display: flex;
  align-items: center;
  padding: 12px;
  line-height: 40px;
}

.MedicenCata .main .main-right .main-icon .main-icon-b {
  margin-left: 20px;
}

.MedicenCata .main .main-right .main-icon .main-icon-c {
  display: flex;
  margin-left: 28px;
}

.MedicenCata .main .main-right /deep/ .el-table .cell {
  font-size: 12px;
  text-align: center;
}

.MedicenCata .main .main-right /deep/ .el-table td.el-table__cell div {
  text-align: center;
  word-break: break-all;
}
</style>